import { useMember } from "@/hooks/use-member";
import type { PlainRunner } from "@/queries/runner-queries";
import { useAuthenticatedUser } from "@/queries/user-queries";
import { useMemo, type FC } from "react";

export const RunnerCreatedBy: FC<{
    runner: PlainRunner;
}> = ({ runner }) => {
    const { data: user } = useAuthenticatedUser();
    const { member: currentMember } = useMember(user?.id);
    const { member: creatorMember } = useMember(runner.creator?.id);

    const label = useMemo(() => {
        return currentMember?.userId === creatorMember?.userId ? "You" : creatorMember?.fullName || "Unknown";
    }, [creatorMember, currentMember]);

    if (!currentMember || !creatorMember) {
        return;
    }

    return (
        <div data-testid="creator" className="text-sm text-content-primary">
            <span>
                by <span>{label}</span>
            </span>
        </div>
    );
};
